import type { FC } from 'react';

import { useGetDocumentById } from '@/hooks/queries';
type Props = {
  documentId: string | undefined;
};

const Breadcrumb: FC<Props> = ({ documentId }) => {
  const { data } = useGetDocumentById(documentId!);

  return <>{data?.document?.[0]?.Title}</>;
};

export default Breadcrumb;
